(function ($) {

  var Selector = 'div[data-embed-type="textgenerator"]';

  var render = function render($textgendiv) {
    var dataurl = $textgendiv.data('url') || {};
    var uuid = $textgendiv.data('id') || {};
    jQuery.ajax({
      url: dataurl,
      type: 'GET',
      crossDomain: true,
      success: function (data, textStatus, xhr) {
        var regEx = /<body[^>]*>([\s\S]*)<\/body>/ig;
        var match = regEx.exec(data);
        jQuery($textgendiv.html(match[1]));
      }
    });
  };

  /**
   *
   */
  $(Selector).each(function () {
    var $element = $(this);
    render($element);
  });
  $(document).on('pjax:end', function (event, xhr, options) {
    $(options.container).find(Selector).each(function () {
      var $element = $(this);
      render($element);
    });
  });

  //Manuelles Triggern des Schnippsels:
  $(document).on('swr:textgenerator:render', (event, data) => {
    render(data.element);
  });
})(window.jQuery);



